import React from 'react'
import { shallow } from 'enzyme'
import Product from '../features/product/Product'
import EditProduct from '../features/product/EditProduct'
import ProductRow from '../features/product/ProductRow'

describe('<Product />', () => {
  let wrapper, instance, props
  beforeEach(() => {
    props = {
      products: [],
      loan: {
        product: { name: 'test' }
      }
    }
    wrapper = shallow(<Product {...props} />)
    instance = wrapper.instance()
  })
  describe('#onEditToggle', () => {
    describe('when isEditable is false', () => {
      beforeEach(() => {
        wrapper = shallow(<Product {...props} />)
        instance = wrapper.instance()
        wrapper.setState({ isEditable: false })
      })
      it('should change isEditable to true', () => {
        instance.onEditToggle()
        expect(wrapper.state('isEditable')).toBeTruthy()
      })
    })
    describe('when isEditable is true', () => {
      beforeEach(() => {
        wrapper = shallow(<Product {...props} />)
        instance = wrapper.instance()
        wrapper.setState({ isEditable: true })
      })
      it('should change isEditable to false', () => {
        instance.onEditToggle()
        expect(wrapper.state('isEditable')).toBeFalsy()
      })
    })
  })
  describe('#render', () => {
    describe('when isEditable is true', () => {
      beforeEach(() => {
        wrapper.setState({ isEditable: true })
      })
      it('should return an <EditProduct />', () => {
        expect(wrapper.find(EditProduct)).toHaveLength(1)
      })
    })
    describe('when isEditable is false', () => {
      beforeEach(() => {
        wrapper = shallow(<Product {...props} />)
        instance = wrapper.instance()
        wrapper.setState({ isEditable: false })
      })
      it('should return a <ProductRow />', () => {
        expect(wrapper.find(ProductRow)).toHaveLength(1)
      })
    })
  })
})
